import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { SelectEl } from "common/components/select";
import { TooltipEl } from "common/components/tooltip";
import { CalendarInputEl } from "common/widgets/date-range-picker/calendar-input";
import { CheckboxEl } from "common/components/checkbox";
import { DisplayType } from "common/components/tooltip/types";
export function template() {
  const {
    dateRange
  } = this.state;
  const invalidDateRangeError = !this.helpers.isValidDateRange();
  const dateLimitedError = !invalidDateRangeError && !this.helpers.isWithinMaxHistoryLimit();
  const {
    window
  } = dateRange;
  return /* @__PURE__ */ jsx("div", { sel: ".date-range-picker-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.helpers.showUpsell() && /* @__PURE__ */ jsx("div", { sel: ".upsell-header" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "lightning-bolt"
  } }), /* @__PURE__ */ jsx("div", { sel: ".upsell-text" }, /* @__PURE__ */ jsx("a", { sel: ".upgrade-link", attrs: {
    href: "/pricing",
    target: "_blank"
  } }, "Upgrade your plan to query beyond ", this.helpers.maxHistoryDaysText()))), /* @__PURE__ */ jsx("div", { sel: ".builder-pane-dropdown-container" }, /* @__PURE__ */ jsx(SelectEl, { params: {
    sections: dateRange.getDateRangeTypeDisplaySections(dateRange.type)
  }, on: {
    change: this.helpers.changedDateRangeType
  }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".date-range-picker" }, [this.helpers.DateRangeType.RelativeAfter, this.helpers.DateRangeType.RelativeBefore, this.helpers.DateRangeType.NotRelativeAfter].includes(dateRange.type) ? /* @__PURE__ */ jsx("div", { sel: ".relative-range-picker" }, /* @__PURE__ */ jsx("input", { sel: ".relative-range-value", class: {
    error: invalidDateRangeError || dateLimitedError
  }, attrs: {
    type: "number",
    value: !Number.isInteger(window.value) ? "" : window.value
  }, on: {
    mouseenter: this.helpers.mouseenterRangeInput,
    mouseleave: this.helpers.mouseleaveRangeInput,
    blur: this.helpers.blurredRangeInput,
    focus: this.helpers.focusedRangeInput,
    change: (ev) => ev.stopPropagation(),
    input: this.helpers.changedRelativeRangeValue
  }, hook: {
    insert: (vnode) => requestAnimationFrame(() => vnode.elm.select())
  }, key: dateRange.type }), /* @__PURE__ */ jsx(SelectEl, { attrs: {
    options: dateRange.getTimeUnitOptions().map((unit) => this.helpers.TIME_UNIT_DISPLAY_NAMES[unit]),
    "selected-option": this.helpers.TIME_UNIT_DISPLAY_NAMES[window.unit]
  }, on: {
    change: this.helpers.changedRelativeRangeUnit
  } }), dateLimitedError && this.helpers.isRangeInputActive() && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    type: DisplayType.Error,
    "always-show": true
  } }, this.helpers.dateLimitedTooltipText())) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(CalendarInputEl, { attrs: this.helpers.filterAttributes({
    from: dateRange.getCalendarFromDate() || "",
    to: dateRange.getCalendarToDate() || "",
    "max-date": this.attr("max-date") || dateRange.getCalendarMaxDate(),
    "max-history-days": this.helpers.maxHistoryDays(),
    "is-range": dateRange.type === this.helpers.DateRangeType.Between || dateRange.type === this.helpers.DateRangeType.NotBetween,
    "min-days-apart": 1,
    "show-upsell": this.helpers.showUpsell()
  }), on: {
    change: this.helpers.changedDates,
    draw: this.helpers.propagateEvent
  }, key: dateRange.type, hook: {
    insert: this.helpers.handleInsertCalendarInput
  } }), dateRange.canUseRolling() && /* @__PURE__ */ jsx(CheckboxEl, { sel: ".rolling-checkbox", attrs: {
    checked: dateRange.isRolling()
  }, on: {
    click: this.helpers.clickedRollingCheckbox
  } }, /* @__PURE__ */ jsx("div", { sel: ".rolling-text" }, this.helpers.getRollingCheckboxText(), /* @__PURE__ */ jsx("div", { sel: ".rolling-info-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  } }), /* @__PURE__ */ jsx(TooltipEl, null, this.helpers.getRollingInfoText()))))), this.helpers.showMaxDateContext() && /* @__PURE__ */ jsx("div", { sel: ".date-range-picker-context" }, /* @__PURE__ */ jsx("div", { sel: ".date-range-picker-context-text" }, this.helpers.maxDateContextText(), /* @__PURE__ */ jsx("div", { sel: ".date-range-picker-context-icon", class: {
    "override-z-index": this.helpers.overrideMaxDateContextZIndex()
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  } }), /* @__PURE__ */ jsx(TooltipEl, null, this.helpers.maxDateTooltipText()))))));
}
